module.exports = "img/flags/KI.b89fedc.png";